import gql from 'graphql-tag';

const accountAddresses = gql`
  fragment accountAddresses on Account {
    id
    addresses {
      id
      name
      address_line_1
      address_line_2
      city
      state
      post_code
      country {
        id
        name
      }
    }
  }
`;

export default accountAddresses;
